// Aviation epaulette: dark shoulder board with gold stripes, optional command
// wings, and optional command stars (used to distinguish Captain-grade ranks).
const Star = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 7.1-1.01L12 2z" />
  </svg>
);

export const Epaulette = ({ stripes = 1, wings = false, stars = 0, className = "" }) => (
  <div
    className={`relative flex h-24 w-16 flex-col items-center justify-end gap-1.5 rounded-md bg-gradient-to-b from-[#1a1c26] to-[#0f1017] p-2 shadow-inner ring-1 ring-white/10 ${className}`}
  >
    {wings && (
      <span className="absolute left-1/2 top-2 -translate-x-1/2 text-[#D4AF37]">
        <svg width="34" height="10" viewBox="0 0 34 10" fill="currentColor" aria-hidden>
          <path d="M17 0l2 3 15 2-15 1-2 4-2-4L0 5l15-2 2-3z" />
        </svg>
      </span>
    )}
    {stars > 0 && (
      <div className="flex items-center justify-center gap-0.5 text-[#F2C94C]" data-testid="epaulette-stars">
        {Array.from({ length: stars }).map((_, i) => (
          <Star key={i} />
        ))}
      </div>
    )}
    <div className="flex w-full flex-col items-center gap-1 pb-0.5">
      {Array.from({ length: Math.max(1, stripes) }).map((_, i) => (
        <span key={i} className="h-1.5 w-full rounded-sm bg-gradient-to-r from-[#B8860B] via-[#F2C94C] to-[#B8860B]" />
      ))}
    </div>
  </div>
);
